<template>
  <page-section
    :section-name="name"
    :content="textContent"
    wrapper-class="bg-white py-6"
  >
    <template #header="{ content }">
      <div class="container mx-auto px-6">
        <h2 v-html="content.title" class="lowercase text-green" />
      </div>
    </template>
    <template v-slot="{ content }">
      <div class="tiles font-sans py-6">
        <fade-shift ratio="0.1" class="row">
          <div class="text">
            <p v-html="content.tiles[0]" />
          </div>
          <div class="logo" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img class="brand" role="presentation" :src="images[0]" />
            </div>
          </div>
        </fade-shift>
        <fade-shift ratio="0.2" class="row">
          <div class="text">
            <p v-html="content.tiles[1]" />
          </div>
          <div class="logo" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img class="brand" role="presentation" :src="images[1]" />
            </div>
          </div>
        </fade-shift>
        <fade-shift ratio="0.3" class="row">
          <div class="text">
            <p v-html="content.tiles[2]" />
          </div>
          <div class="logo" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img class="brand" role="presentation" :src="images[2]" />
            </div>
          </div>
        </fade-shift>
        <fade-shift ratio="0.4" class="row">
          <div class="text">
            <p v-html="content.tiles[3]" />
          </div>
          <div class="logo" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img class="brand" role="presentation" :src="images[3]" />
            </div>
          </div>
        </fade-shift>
      </div>
    </template>
  </page-section>
</template>

<script>
export default {
  name: "HightlightingIssuesForElection2019",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  data() {
    return {
      name: "hightlightingIssuesForElection2019",
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
    images() {
      const images = [
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/cdntaxfairness.jpg"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/cdnhealthcolition.jpg"),
        require("../assets/images/Photos/Highlighting_issues_for_election_2019/ICLMG.jpg"),
      ];

      if (this.locale === "fr") {
        images.splice(
          2,
          0,
          require("../assets/images/Photos/Highlighting_issues_for_election_2019/eathinkvote-fr.jpg")
        );
      } else {
        images.splice(
          2,
          0,
          require("../assets/images/Photos/Highlighting_issues_for_election_2019/eathinkvote.jpg")
        );
      }

      return images;
    },
  },
};
</script>

<style lang="scss">
#page-hightlightingIssuesForElection2019 {
  h2 {
    small {
      margin-top: -0.25rem;
      margin-left: 3rem;
    }

    strong {
      @apply leading-11;

      margin-left: -0.25rem;
    }

    @screen lg {
      small {
        margin-left: 5rem;
      }

      strong {
        @apply leading-17;
      }
    }
  }

  .tiles {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 2rem;

    @screen md {
      .row {
        @apply px-16;
      }
    }

    @screen lg {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr;

      .row {
        @apply px-0;
      }
    }

    .row {
      display: grid;
      position: relative;
      grid-template-areas:
        "image"
        "text";
      grid-template-columns: 1fr;
      grid-template-rows: 6rem auto;
      align-items: center;
      justify-items: center;
      gap: 3rem;

      .text {
        position: relative;
        grid-area: text;
        align-self: flex-start;
      }

      .logo {
        display: flex;
        position: relative;
        grid-area: image;
        align-items: center;
        justify-content: center;

        img {
          width: 6rem;
        }

        .brand {
          position: absolute;
          top: 0;
          padding: 0.25rem;
          border-radius: 100%;
        }

        &::after {
          content: " ";
          position: absolute;
          top: 100%;
          width: 6px;
          height: 2.5rem;
          background-image: url("../assets/images/dotted_line-short.svg");
          background-repeat: no-repeat;
          background-position: bottom;
          background-origin: content-box;
          background-size: 100%;
        }
      }

      &:not(:first-of-type) {
        &::before {
          content: " ";
          display: flex;
          position: absolute;
          top: -7rem;
          width: 3px;
          height: 12rem;
          transform: rotate(90deg);
          background-image: url("../assets/images/dotted_line-long.svg");
          background-repeat: no-repeat;
          background-position: bottom;
          background-origin: content-box;
          background-size: 100%;
        }

        @screen lg {
          &::before {
            content: none;
          }

          .text::before {
            content: " ";
            display: flex;
            position: absolute;
            left: calc(-1.5rem + 2px);
            width: 3px;
            height: 12rem;
            background-image: url("../assets/images/dotted_line-long.svg");
            background-repeat: no-repeat;
            background-position: bottom;
            background-origin: content-box;
            background-size: 100%;
          }
        }
      }
    }
  }
}
</style>
